export enum StorageLocationType {
    StorageCabinet = 0,
    OperatingRoom = 1,
    AmbulanceBag = 2,
}

export interface StorageLocation {
    id: string;
    digitalId: string | null;
    name: string;
    location: string;
    description: string | null;
    isSatelliteStorage: boolean;
    isDeleted: boolean;
    barCode: string | null;
    type: StorageLocationType;
}
